import { Box, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useEffect, useState } from "react";
import Onboarding from "@/components/onboarding/Onboarding";
import { localStorageWrapper } from "@/utils/storage";
import useTagEvent from "../hooks/useTagEvent";
import { randomAlphaNumeric } from "@/utils/strings";
import { PROFILE } from "@/graphql/queries/profile";
import { useQuery } from "@apollo/client";

export default function OnboardingMenu({ isFirstLesson }) {
    const [display, setDisplay] = useState(false);
    const [displayButton, setDisplayButton] = useState(false);
    const [id, setId] = useState(null);

    const { sendEvent } = useTagEvent();

    const { data: { profile } = {}, loading } = useQuery(PROFILE, {
        fetchPolicy: "cache-first",
    });

    const userId = profile?.userId ?? "";

    useEffect(() => {
        if (
            isFirstLesson &&
            userId &&
            !localStorageWrapper.getOnboardingAutoPlayedForFirstLesson(userId)
        ) {
            setDisplay(true);
        }
    }, [isFirstLesson, userId]);

    useEffect(() => {
        if (!id) {
            setId(randomAlphaNumeric(16));
        }

        if (localStorageWrapper.getOnboardingAutoPlayedForFirstLesson(userId)) {
            setDisplayButton(true);
        }
    }, [userId]);

    if (loading) return <></>;

    return (
        <>
            <Box id="onboarding-menu" sx={{ marginRight: "6px" }}>
                {(!isFirstLesson || displayButton) && (
                    <IconButton
                        id="onboarding-menu-button"
                        size="medium"
                        onClick={() => {
                            sendEvent("intro_menu_clicked", {
                                version: "1",
                                id,
                            });
                            setDisplay(true);
                        }}
                    >
                        <InfoOutlinedIcon />
                    </IconButton>
                )}
            </Box>
            {display && (
                <Onboarding
                    display={true}
                    profile={profile}
                    onOpened={() => {
                        sendEvent("intro_opened", { version: "1", id });
                    }}
                    onClosedClicked={({ stepId }) => {
                        sendEvent("intro_closed", {
                            stepId: stepId,
                            version: "1",
                            id,
                        });
                    }}
                    onDoneClicked={() => {
                        sendEvent("intro_finished", { version: "1", id });
                    }}
                    onFinsiehd={() => {
                        setDisplay(false);
                        setId(randomAlphaNumeric(16));
                    }}
                    onRequestFinale={() => {
                        setDisplayButton(true);
                        if (
                            isFirstLesson &&
                            !localStorageWrapper.getOnboardingAutoPlayedForFirstLesson(
                                userId
                            )
                        ) {
                            localStorageWrapper.setOnboardingAutoPlayedForFirstLesson(
                                userId
                            );
                        }
                    }}
                />
            )}
        </>
    );
}
